import React from 'react';
import Header from '../components/Header';
import WhyUsHero from '../components/WhyUs/WhyUsHero';
import WhyUsFeatures from '../components/WhyUs/WhyUsFeatures';
import WhyUsStats from '../components/WhyUs/WhyUsStats';
import WhyUsTestimonials from '../components/WhyUs/WhyUsTestimonials';
import WhyUsCTA from '../components/WhyUs/WhyUsCTA';
import WaveGraphic from '../components/WhyUs/WaveGraphic';
import LeadingWaySection from '../components/WhyUs/WhyUsFeatures';

const WhyUs = () => {
  return (
    <div className="min-h-screen">
      {/* Header */}
      <Header />
      
      {/* Hero Section */}
      <WhyUsHero />

      <WaveGraphic />
      
      {/* Features Section */}
      <LeadingWaySection />
      
      {/* Stats Section */}
      <WhyUsStats />
      
    
    </div>
  );
};

export default WhyUs;
